import { PurchaseResultContainer } from "../../organisms/purchase-result/purchase-result-container";
import { MainTemplate } from "../../template/main-template/main-template";

export const PurchasePage = () => (
  <MainTemplate>
    <PurchaseResultContainer />
  </MainTemplate>
);
